var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyrecive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Broken/moneyrecive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4743 25.204C17.4743 26.9824 18.8493 28.4124 20.536 28.4124H23.9826C25.4493 28.4124 26.641 27.1657 26.641 25.6074C26.641 23.939 25.9076 23.334 24.826 22.949L19.3076 21.024C18.226 20.639 17.4926 20.0524 17.4926 18.3657C17.4926 16.8257 18.6843 15.5607 20.151 15.5607H23.5976C25.2843 15.5607 26.6593 16.9907 26.6593 18.769M22.0576 13.7494V30.2494M31.2243 5.49935V12.8327H38.5576M40.391 3.66602L31.2243 12.8327",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0577 3.66602C11.9377 3.66602 3.72437 11.8794 3.72437 21.9994C3.72437 29.2227 7.90437 35.4744 13.991 38.4627M40.391 21.9994C40.391 32.1194 32.1777 40.3327 22.0577 40.3327",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyrecive);
export default __webpack_public_path__ + "static/media/moneyrecive.c53bd17aad1c4cec270e6e38598c3498.svg";
export { ForwardRef as ReactComponent };